// Ícone circular "i" — o texto de ajuda vive num tooltip que só aparece no hover/foco, em vez
// de ficar sempre visível abaixo do campo (era isso que inchava os formulários de Obra).
const InfoTooltip = ({ text }) => (
  <span className="info-tooltip" tabIndex={0}>
    <span className="info-tooltip-icon">i</span>
    <span className="info-tooltip-content">{text}</span>
  </span>
)

export default InfoTooltip;
